/**
 * Subscription Module - Mutation Services
 */

import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../../services/useApi';
import {
  INITIATE_SUBSCRIPTION_PAYMENT_URL,
  ON_PAYMENT_INITIATED_URL,
} from '../constants';
import {
  IApiResponse,
  IInitiatePaymentResponse,
  IOnPaymentInitiatedRequest,
  IOnPaymentInitiatedResponse,
} from '../types';

export const useInitiateSubscriptionPayment = () => {
  const { apiPrivate } = useApi();

  return useMutation<IInitiatePaymentResponse, Error, { planId: number }>({
    mutationFn: async ({ planId }) => {
      const { data } = await apiPrivate.post<IApiResponse<IInitiatePaymentResponse>>(
        `${INITIATE_SUBSCRIPTION_PAYMENT_URL}?planId=${planId}`
      );
      return data.result;
    },
  });
};

export const useOnPaymentInitiated = () => {
  const { apiPublic } = useApi();

  return useMutation<IOnPaymentInitiatedResponse, Error, IOnPaymentInitiatedRequest>({
    mutationFn: async (body) => {
      const { data } = await apiPublic.post<IApiResponse<IOnPaymentInitiatedResponse>>(
        ON_PAYMENT_INITIATED_URL,
        body
      );
      return data.result;
    },
  });
};
